/** Return a function that when called calls all of the provided functions. */
// NOTE: Mainly intend this as a convenience when wanting to pass multiple signals as the 1st param to `S.on`.
// There's an inconsistency in the current version of S (0.4.9 as of this writing) in that the runtime supports
// an array as the 1st param to `S.on`, in which case it behaves exactly as using this `callAll` util would,
// but the TS typings only allow a signal as the 1st param to `S.on`, not an array. Using `callAll` to avoid
// depending on the undocumented array behavior.
export const callAll = (...callees : (() => void)[]) => () => {
    for (let callee of callees) callee();
};



// WEBPACK FOOTER //
// ./lib/callAll.ts